<template>
  <div class="progress-wrap">
    <div class="progress-line" :style="{width: progressPercent}"></div>
  </div>
</template>

<script>
import ProgressBarMixin from 'mixins/ProgressBarMixin'

export default {
  name: 'ProgressBar',
  props: {
    reloadMarker: Function
  },
  mixins: [
    ProgressBarMixin
  ]
}
</script>

<style scoped lang="scss">
.progress-wrap {
    width: 100%;
    height: 5px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(130, 119, 118, 0.7);
}
.progress-line {
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color:rgb(28, 164, 234);

    &.disabled {
        background-color: #909090;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ProgressBar.vue